class Autoplay2 {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
    }
    run() {
        const onIntersection = (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.intersectionRatio >= 0.2) {
                    video.play();
                } else if (entry.intersectionRatio <= 0.2) {
                    video.pause();
                }
            });
        };

        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0.2],
        };

        const observer = new IntersectionObserver(onIntersection, observerOptions);
        document.querySelectorAll('[data-autoplay-2]').forEach((video) => observer.observe(video));

        window.addEventListener('filter:change', () => {
            document.querySelectorAll('[data-autoplay-2]').forEach((video) => observer.observe(video));
        })
    }
}

export default Autoplay2